// extracted by mini-css-extract-plugin
export var marginNegative = "_5q-5 _5q-3 _5q-1";
export var marginPositive = "_5q-4 _5q-3 _5q-1";
export var modalContent = "_5q-6";
export var samplesTable = "_5q-8";
export var samplesTableContainer = "_5q-7";
export var statBox = "_5q-a";
export var tableCell = "_5q-1";
export var tableCellCenter = "_5q-2 _5q-1";
export var tableCellRight = "_5q-3 _5q-1";
export var tableHeader = "_5q-0";
export var trackingNumber = "_5q-9";